import { useCallback } from 'react'

import history from '@/routes/history'

import useAuth from './use-auth'
import { useAuthPageNavigation } from '../context/auth-page-navigation-context'
import {
  buildLoginPath,
  buildSignupPath,
  getFullReturnPath,
} from '../utils/auth-return'

export function useAuthNavigation () {
  const authPageNav = useAuthPageNavigation()
  const {
    openLoginModal,
    openSignupModal,
    openForgotPasswordModal,
    closeModal,
  } = useAuth()

  const goToLogin = useCallback(() => {
    if (authPageNav?.isAuthPage) {
      authPageNav.goToLogin()
      return
    }
    openLoginModal()
  }, [authPageNav, openLoginModal])

  const goToSignup = useCallback(() => {
    if (authPageNav?.isAuthPage) {
      authPageNav.goToSignup()
      return
    }
    openSignupModal()
  }, [authPageNav, openSignupModal])

  const goToForgotPassword = useCallback(() => {
    if (authPageNav?.isAuthPage) {
      authPageNav.goToForgotPassword()
      return
    }
    openForgotPasswordModal()
  }, [authPageNav, openForgotPasswordModal])

  const dismissAuth = useCallback(() => {
    if (authPageNav?.isAuthPage) {
      history.push('/')
      return
    }
    closeModal()
  }, [authPageNav, closeModal])

  const goToLobby = useCallback(() => {
    if (authPageNav?.isAuthPage) {
      history.push('/')
      return
    }
    closeModal()
    history.push('/')
  }, [authPageNav, closeModal])

  return {
    goToLogin,
    goToSignup,
    goToForgotPassword,
    dismissAuth,
    goToLobby,
    isAuthPage: Boolean(authPageNav?.isAuthPage),
  }
}

export function useNavigateToAuthPages () {
  const navigateToLogin = useCallback((returnPath) => {
    history.push(buildLoginPath(returnPath || getFullReturnPath(window.location)))
  }, [])

  const navigateToSignup = useCallback(({ returnPath, referer, currentSearch } = {}) => {
    history.push(buildSignupPath({ returnPath, referer, currentSearch }))
  }, [])

  return { navigateToLogin, navigateToSignup }
}
